/** Outris brand chrome for Workbench — graph semantics stay in Cytoscape stylesheets. */
export const workbenchHeaderShell =
    'bg-card border-b border-border';

/** Floating panel over the live canvas: hairline plus overlay blur, no drop shadow. */
export const workbenchSurface =
    'bg-card/95 backdrop-blur-md border border-border';

/** Popovers and menus over the canvas: overlay shadow plus hairline. */
export const workbenchSurfacePopover =
    'bg-card/95 backdrop-blur-md border border-border shadow-overlay';

/** Nested cards inside docked chrome: solid surface, hairline only. */
export const workbenchInset =
    'bg-card border border-border';

export const workbenchOmnibar =
    'bg-background/80 border border-input/60 focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors';

export const workbenchPrimaryBtn =
    'bg-primary text-primary-foreground hover:bg-brand-gold-hover font-medium transition-colors';

export const workbenchGhostBtn =
    'bg-primary/10 text-primary border border-primary/30 hover:bg-primary/20 transition-colors';

export const workbenchActiveChip =
    'border-primary/50 bg-primary/15 text-primary font-semibold';

export const workbenchInspectorTabActive =
    'border-primary text-primary';

export const workbenchInspectorTabIdle =
    'border-transparent text-muted-foreground/70 hover:text-primary/80';
